import React, { useEffect, useState } from 'react'
import VerifyImage from './transparent.png';
import { getVerifyToken } from '../../services/medium';
import { useParams, useSearchParams } from 'react-router-dom';
import ProtectedImage from './ProtectedImage';

export default function VerySoulVerifiedBatchTransparent() {
    const params = useParams();
    const [searchParams] = useSearchParams();
    const width = searchParams.get("width");
    const height = searchParams.get("height");
    const [is_verify_token, setis_verify_token] = useState('');

    useEffect(() => {
        getVerifyToken(params.id).then((data) => {
            if (data.data.data) {
                setis_verify_token(data.data.data.is_verify_token)
            }

        }).catch(() => { })
    }, [params])

    return (
        <>
            {(is_verify_token === 2 || is_verify_token === 1) ? <a target='_blank' style={{

                width: width,
                // height: '222px',
                userSelect: "none",
                WebkitUserDrag: "none",
                cursor: 'pointer',
                display: 'block'
            }} href='https://verified.verysoul.com/'> <ProtectedImage src={VerifyImage} width={width} height={height} /> </a> : ''}

        </>
    )
}

